import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogInsurance } from "../../store/catalog/actions";
export var GetCatalogInsurance = function (trigger, enable, page, limit, clientId, planId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseGetCatalogInsurance: state.Catalog.responseGetCatalogInsurance,
        loadingGetCatalogInsurance: state.Catalog.loadingGetCatalogInsurance,
        errorGetCatalogInsurance: state.Catalog.errorGetCatalogInsurance,
    }); }), responseGetCatalogInsurance = _a.responseGetCatalogInsurance, loadingGetCatalogInsurance = _a.loadingGetCatalogInsurance, errorGetCatalogInsurance = _a.errorGetCatalogInsurance;
    useEffect(function () {
        if (!trigger)
            return;
        dispatch(getCatalogInsurance({
            enable: enable,
            page: page,
            limit: limit,
            type: "CATALOG_INSURED_TYPE",
            clientId: clientId,
            planId: planId,
        }));
    }, [trigger, enable, page, limit, clientId, planId]);
    return {
        responseGetCatalogInsurance: responseGetCatalogInsurance,
        loadingGetCatalogInsurance: loadingGetCatalogInsurance,
        errorGetCatalogInsurance: errorGetCatalogInsurance,
    };
};
